import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnpermissionService } from './../../../../core/services/esnpermission/esnpermission.service';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from 'rxjs';
import Swal from 'sweetalert2';
import { serverError } from '@core/models/messages';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-settings-permissions',
  templateUrl: './settings-permissions.component.html',
  styleUrls: ['./settings-permissions.component.css'],
})
export class SettingsPermissionsComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  searchElement: string = '';
  formrole: FormGroup = this.createRoleForm();
  private unsubscribeAll: Subject<void> = new Subject();
  listrole: any;
  mode: string = 'create_role';
  searchInputSubject = new Subject<string>();
  totalItems!: number;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  startIndex: number = 0;
  endIndex: number = 5;
  id_role!: number;
  pagination : boolean =false;
  /* modal */
  modalRef?: BsModalRef;
  clickCount: number = 0;

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private roleservice: EsnpermissionService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef
  ) {}

  ngOnInit() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.getListrole();
 
  }

  customNameValidator(control: AbstractControl) {
    const forbiddenPattern = /responsable|Responsable|Responsab|responsab/;

    if (forbiddenPattern.test(control.value)) {
      return { forbiddenName: true };
    }

    return null;
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  createRoleForm(data?: any) {
    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required],
      ],
    });
  }
    
 
  getListrole() {
    let data = {
      per_page: this.pageSize,
      page: this.currentPage,
    };
    this.spinner.show();
    this.roleservice.getlisteroles(data).subscribe({
      next: (response) => {
        if (response.data) {
          this.listrole = response.data.data;
          this.totalItems=response.data.total
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      },
    });
  }

  openModal(template: TemplateRef<any>, mode: string, data?: any) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.mode = mode;
    this.getListrole();

    if (mode === 'update_role') {
      this.id_role = data?.id;
      this.formrole = this.createRoleForm(data);
    } else {
      this.formrole = this.createRoleForm();
    }
  }
  closeModal() {
    this.modalRef!.hide();
    this.formrole.reset();
  }
  deleterole(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.roleservice.deleterole(id).subscribe(
          (res: any) => {
            this.toastrService.success('Le rôle a été supprimé avec succès.');
            this.getListrole();
          },
          (error) => {
            if (error.error.message === 'The admin role cannot be deleted.') {
              this.toastrService.error(
                'Le rôle Admin ne peut pas être supprimé.'
              );
            }
            else if(error.error.status ===400 && error.error.message === 'This role has employees and cannot be deleted.') {
              this.toastrService.error(
                'Le role et assoccié a un intervenant et ne peut pas être supprimé.'
              );
            }
          }
        );
      }
    });
  }

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.searchInputSubject.next(filterValue);
  // }
  applyFilter(pageNumber : number = this.currentPage) {
    this.btnSearchactive=true;
    if (this.searchElement != '' || this.clickCount) {
      this.clickCount++;
     
      const data = {
        search: this.searchElement.trim().toLowerCase(),
        per_page: this.pageSize,
        page: this.currentPage
      };
      this.spinner.show();
      this.roleservice.searchListRole(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.listrole = res.data;
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
            this.toastrService.error(serverError);
          },
        });
    }
  }
  choseUpdateCreateRole() {
    if (this.mode == 'create_role') {
      if (!this.isSubmitting) {
        this.createRole();
      }
    } else {
      this.updateRole();
    }
  }

  isSubmitting = false;
  createRole() {
    this.spinner.show();
    this.formrole.markAllAsTouched();
    this.formrole.markAsDirty();

    const payload = {
      name: this.formrole.value.name,
    };

    if (this.formrole.valid && !this.isSubmitting) {
      this.isSubmitting = true; // Variable to disable the button
      this.roleservice.createRole(payload).subscribe({
        next: () => {
          this.toastrService.success('Le rôle a été ajouté avec succès');
          this.getListrole();
          this.close_modal_add();
          this.resetform(); // Reset the form after success
        },
        error: (error : any) => {
          this.spinner.hide();
          let name = this.formrole.value.name;
          if (
            error?.error.message.name &&
            error?.error.message.name[0] ===
              'The role has already exsist for this company.'
          ) {
            this.toastrService.error(
              `Le rôle ` +
                name +
                ` existe déjà. Veuillez choisir un nom de rôle différent.`
            );
          } else {
            this.toastrService.error(
              "Une erreur s'est produite lors de l'ajout du rôle"
            );
          }
          this.isSubmitting = false; // Re-enable the button on error
        },
        complete: () => {
          this.isSubmitting = false; // Re-enable the button on complete
          this.spinner.hide();
        },
      });
    } else if (!this.formrole.valid) {
      this.spinner.hide();
      this.toastrService.error('Veuillez remplir tous les champs obligatoires');
    }
  }

  updateRole() {
    this.spinner.show();
    this.formrole.markAllAsTouched();
    this.formrole.markAsDirty();
    const payload = {
      name: this.formrole.value.name,
    };

    this.isSubmitting = true; // Set submitting flag to true
    this.roleservice.updateRole(payload, this.id_role).subscribe({
      next: () => {
        this.toastrService.success('Le rôle a été modifié avec succés ');
        this.getListrole();
        this.close_modal_add();
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        let name = this.formrole.value.name;
        if (
          error?.error.message.name &&
          error?.error.message.name[0] ===
            'The role has already exsist for this company.'
        ) {
          this.toastrService.error(
            `Le rôle ` +
              name +
              ` existe déjà. Veuillez choisir un nom de rôle différent.`
          );
        } else {
          this.toastrService.error(
            "Une erreur s'est produite lors de l'ajout du rôle"
          );
        }
      },
    });
  }
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
    if (this.btnSearchactive) {
      this.applyFilter(this.currentPage);
    } 
    else {
      this.getListrole();
    }
  }
  onReset(){
    this.currentPage=0;
    this.getListrole()
 } 
  close_modal_add() {
    let btnClose = document.getElementById('ModalClose_add_role');
    this.formrole.reset();
    if (btnClose) {
      btnClose.click();
    }
    // this.submitted = false;
    // this.goToAdd()
  }
  resetform() {
    this.formrole.reset();
    this.isSubmitting = false;
  }
}
